import { normalizeAssignedTo } from "../utils/ticketAssignmentUtils";

export const TICKET_AGENTS = [
  { key: "alosia", value: "alosia", label: "Alosia" },
  { key: "chetan", value: "chetan", label: "Chetan" },
  { key: "sanjiv", value: "sanjiv", label: "Sanjiv" },
  { key: "vara", value: "vara", label: "Vara" },
  { key: "rishika", value: "rishika", label: "Rishika" },
  { key: "kritika", value: "kritika", label: "Kritika" },
  { key: "sunil", value: "sunil", label: "Sunil" },
];

export const TICKET_AGENT_OPTIONS = TICKET_AGENTS.map((agent) => ({
  label: agent.label,
  value: agent.value,
}));
export { normalizeAssignedTo };
